import PubSub from "pubsub-js"

/**
 * Tracking consent shared by the ad trackers (Google, Microsoft, Facebook).
 *
 * The choice is kept in localStorage so pages/+Head.jsx can read it
 * synchronously and set the consent-mode defaults before any tag loads.
 * `null` means the visitor has not decided yet; the banner is shown and the
 * tags run in denied (cookieless) mode until they do.
 */
export const CONSENT_STORAGE_KEY = "tracking_consent"
export const CONSENT_EVENT = "Tracking_Consent"

export const getConsent = () => {
  try {
    const value = localStorage.getItem(CONSENT_STORAGE_KEY)
    return value === "granted" || value === "denied" ? value : null
  } catch (e) {
    return null
  }
}

/**
 * Whether the visitor has not been asked at all: pages/+Head sets
 * window.__consentRequired from the visitor's country (see consent-geo).
 */
export const isConsentRequired = () => {
  try {
    return window.__consentRequired !== false
  } catch (e) {
    return true
  }
}

// Undecided visitors outside the consent countries count as granted
export const hasConsent = () => {
  const stored = getConsent()
  if (stored) return stored === "granted"
  return !isConsentRequired()
}

/**
 * Store the visitor's choice and push it to every tag as a consent update.
 * @param {"granted"|"denied"} value
 */
export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, value)
  } catch (e) {
    // storage unavailable: the choice lives for this page only
  }

  // Google consent mode v2
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: value,
      ad_user_data: value,
      ad_personalization: value,
      analytics_storage: value,
    })
  }

  // Microsoft UET consent mode
  window.uetq = window.uetq || []
  window.uetq.push("consent", "update", { ad_storage: value })

  // Facebook pixel listens through FacebookTracking
  PubSub.publish(CONSENT_EVENT, value)
}
